<div class="tab-container m-t-16">
  <mc-tab-bar (tabchange)="onTabChanged($event)" [currentindex]="setIndex">
    <mc-tab slot="tab" label="My Queue"></mc-tab>
    <div slot="panel"></div>
    <mc-tab slot="tab" label="My Pool"></mc-tab>
    <div slot="panel"></div>
  </mc-tab-bar>
</div>
@if (showGrid) {
  <app-approval-l3-wo-grid [filterFormGroup]="filterFormGroup" [selectedTabVal]="selectedTabVal"></app-approval-l3-wo-grid>
}
